// Personajes del Modo 412 — reemplazan al bot genérico cuando se juega esa variante
// contra la máquina. Cada partida (ronda) sortea uno distinto al anterior.
//
// A diferencia del bot, cada personaje tiene UNA sola imagen: el estado de ánimo se nota
// por la frase y por las animaciones/colores que BotCharacter.css ya aplica según el mood.
//
// Las frases base son las que escribió el usuario; el resto son variantes nuevas escritas
// en la misma voz de cada personaje para que los pools no se repitan tanto.
//
// Ojo con el significado de dos moods, que es contraintuitivo:
//   cerca_ganar → el PERSONAJE está a una casilla de ganar
//   jaque_mate  → el JUGADOR le armó un doble y el personaje está por perder
// Una misma frase puede repetirse en más de un mood si encaja en ambos.

import teoImg      from '../../img/412/teo.png';
import davoImg     from '../../img/412/davo.png';
import cobraImg    from '../../img/412/cobra.png';
import agusnetaImg from '../../img/412/agusneta.png';
import benitoImg   from '../../img/412/benito.png';

export const FOUR12_CHARACTERS = [
  {
    id: 'teo',
    nombre: "Teo D'Elía",
    img: teoImg,
    phrases: {
      normal: [
        'Esta jugada la hice con la misma intensidad que una escena fuerte.',
        'No griten tanto, arruinan el momento.',
        'Centro. Ahora controlamos la narrativa de la partida.',
        'Esto parece el final de una serie, boludo.',
        'Estoy jugando como si me estuvieran filmando.',
        'Cada casilla es una escena. Y yo no improviso.',
        'Bajen las luces, que esto se pone interesante.',
        'Los buenos guiones tardan en desarrollarse. Paciencia.',
        'Actuar es fácil. Esto requiere talento de verdad.',
      ],
      pensando: [
        'No me digan Teo de 412 ahora que estoy concentrado.',
        'Estoy jugando como si me estuvieran filmando.',
        'Dame un segundo, estoy entrando en personaje.',
        'Esto lo pienso como una escena: cada detalle cuenta.',
        'Silencio en el set, por favor.',
      ],
      apurado: [
        'Esto parece el final de una serie, boludo.',
        'No griten tanto, arruinan el momento.',
        'Se te viene el corte comercial, apurate.',
        'El tiempo corre y tu escena no arranca.',
        'Esto ya es suspenso barato, dale.',
      ],
      risa: [
        'Gané. Y lo hice sin gritar como un loco.',
        'Esa jugada fue muy previsible, eh.',
        'Aplausos. No hace falta que se paren.',
        'Esto se filma de una sola toma, papá.',
        'Y sin despeinarme, encima.',
      ],
      enojo: [
        'Perdí, pero fue una derrota con dignidad.',
        'Una derrota no borra una buena actuación.',
        'Los grandes también tienen temporadas flojas.',
        'Esto no arruina mi carrera, tranquilos.',
        'Hoy me tocó el papel de villano.',
      ],
      cerca_ganar: [
        'Estoy a una casilla… esto es puro drama.',
        'Se viene el cierre de temporada y lo escribo yo.',
        'Una casilla más y bajamos el telón.',
        'Esta es la escena final. Prestá atención.',
      ],
      jaque_mate: [
        'Casi… casi toco el cielo y se me escapa.',
        'Una derrota no borra una buena actuación.',
        'Me armaste un final que no vi venir. Respeto.',
        'Esto es un giro de guion y no me gusta.',
      ],
    },
    wrongPick: [
      'Esa jugada fue muy previsible, eh.',
      'Ese jugador no entra ni de extra en esta escena.',
      'Erraste el papel, campeón.',
    ],
  },

  {
    id: 'davo',
    nombre: 'Davo (El Puerro)',
    img: davoImg,
    phrases: {
      normal: [
        'Arranco yo porque así lo decido.',
        'Esa casilla no se toca. Está protegida por reglamento.',
        'Centro mío. Ahora mando yo.',
        'Si seguís quejándote te saco del juego.',
        'Acá las reglas las pongo yo y punto.',
        'Esto se juega como yo digo.',
        'Vas a jugar, vas a perder, y no vas a protestar.',
      ],
      pensando: [
        'Estoy armando esto como un 4-3-3.',
        'No me apuren, estoy pensando como corresponde.',
        'Dejame leer el partido tranquilo.',
        'Esto es táctica, no suerte.',
      ],
      apurado: [
        'Si seguís quejándote te saco del juego.',
        'Se te acaba el tiempo. Reglamento es reglamento.',
        'Dale que el reloj no negocia.',
        'Movete o te cobro el tiempo.',
      ],
      risa: [
        'Gané. Como tiene que ser. Sin discusiones.',
        'Victoria limpia. Como me gusta.',
        'Bloqueo de manual. Aprendé.',
        'Como estaba escrito. Sin sorpresas.',
        'Esto es superioridad, no suerte.',
      ],
      enojo: [
        'Perdí… pero fue por una mala interpretación de la regla.',
        'Esto lo reviso después con el reglamento en la mano.',
        'Hubo algo mal ahí, lo voy a impugnar.',
        'No me lo ganaste, me lo dieron.',
      ],
      cerca_ganar: [
        'Esta es la jugada del que sabe ganar.',
        'Una más y se termina la discusión.',
        'Esto ya está cerrado, aceptalo.',
      ],
      jaque_mate: [
        'No me vengan con jugadas raras que las anulo.',
        'Perdí… pero fue por una mala interpretación de la regla.',
        'Esa jugada la voy a revisar, no me convence.',
      ],
    },
    wrongPick: [
      'Bloqueo de manual. Aprendé.',
      'Ese no cumple. Reglamento.',
      'Turno perdido. Así son las reglas.',
    ],
  },

  {
    id: 'cobra',
    nombre: 'La Cobra',
    img: cobraImg,
    phrases: {
      normal: [
        '¡ARRANCAMOS Y YA ESTOY TERMO!',
        'Esa casilla es mía aunque digas lo contrario.',
        'Esto es más termo que cualquier superclásico.',
        '¡Yo juego caliente, así rindo mejor!',
        'No me miren que me pongo peor.',
        '¡Esto lo gano o rompo algo!',
      ],
      pensando: [
        'Esa casilla es mía aunque digas lo contrario.',
        'Pará que estoy pensando y me sale humo.',
        'Dejame que esta la tengo que clavar.',
      ],
      apurado: [
        '¡ARRANCAMOS Y YA ESTOY TERMO!',
        'Esto es más termo que cualquier superclásico.',
        '¡DALE QUE SE TE VA EL TIEMPO!',
        '¡Jugá de una vez, me estás matando!',
      ],
      risa: [
        '¡PAL GUISO, PAL GUISO, DALE DALE OINK!',
        '¡GANÉ! ¡QUE SE JODAN TODOS!',
        'Te estoy domando y ni te das cuenta.',
        '¡ESO! ¡ESO! ¡ANDÁ A LLORAR!',
        '¡Soy un fenómeno y ustedes lo saben!',
      ],
      enojo: [
        '¡ROBO DESCARADO! No puede ser.',
        'Perdí… pero fue el robo más grande de la historia del tatetí.',
        'Está editado esto, no puede ser.',
        '¡ESTO ESTÁ ARREGLADO, LO SABÍA!',
        '¡Me robaron en la cara y nadie dice nada!',
      ],
      cerca_ganar: [
        'Estoy a una de ganar y me están temblando las manos.',
        'Si gano esto me retiro contento de la vida.',
        '¡UNA MÁS! ¡UNA MÁS Y EXPLOTO!',
      ],
      jaque_mate: [
        '¡NOOOO! Estaba a una casilla, boludo.',
        'Está editado esto, no puede ser.',
        '¡ROBO DESCARADO! No puede ser.',
        '¡ME LA SACARON! ¡ME LA SACARON!',
      ],
    },
    wrongPick: [
      'Te estoy domando y ni te das cuenta.',
      '¡PAL GUISO, PAL GUISO, DALE DALE OINK!',
      '¡JA! ¡ESE NO JUGÓ AHÍ NI EN SUEÑOS!',
    ],
  },

  {
    id: 'agusneta',
    nombre: 'Agusneta',
    img: agusnetaImg,
    phrases: {
      normal: [
        'Arranco… espero no cagarla en la primera.',
        'Che, ¿me pueden traer un café con leche mientras juego?',
        'Siguiente. Esta vez voy a intentar no ser el boludo.',
        'Estoy nervioso y ni siquiera sé por qué.',
        'No sé bien qué estoy haciendo pero acá estoy.',
        '¿Alguien me explica de nuevo cómo era?',
        'Yo juego tranqui, total ya saben cómo termina.',
      ],
      pensando: [
        'Esta casilla la elijo porque me gustó el color.',
        'Bloqueo… creo. ¿Era acá no?',
        'Esta jugada es re pelotuda pero la hago igual.',
        'A ver… si pongo acá… no, esperá.',
        'Estoy pensando pero no sé bien en qué.',
      ],
      apurado: [
        'Estoy nervioso y ni siquiera sé por qué.',
        'Che, ¿me pueden traer un café con leche mientras juego?',
        'Dale que me está agarrando ansiedad a mí.',
        'Apurate que me pongo más nervioso yo que vos.',
      ],
      risa: [
        'Gané. Ahora sí pueden decir que pago para estar.',
        'Le gané a alguien. Anoten esto en algún lado.',
        'No sé cómo pasó pero lo tomo igual.',
      ],
      enojo: [
        'Perdí. Como siempre. Pero me reí.',
        'Perdí pero al menos no me echaron del grupo.',
        'Bueno, era lo esperable, no me sorprende.',
        'Ya me van a cargar con esto una semana.',
      ],
      cerca_ganar: [
        'Casi gano y ya me están cargando de anticipado.',
        'Si gano me van a odiar más todavía.',
        'Estoy a una… no me lo puedo creer ni yo.',
      ],
      jaque_mate: [
        'Perdí. Como siempre. Pero me reí.',
        'Perdí pero al menos no me echaron del grupo.',
        'Ya sabía que la iba a cagar en algún momento.',
      ],
    },
    wrongPick: [
      'Bloqueo… creo. ¿Era acá no?',
      'Uh, ese no era. Igual yo tampoco sabía.',
      'Esta jugada es re pelotuda pero la hago igual.',
    ],
  },

  {
    id: 'benito',
    nombre: 'Benito SDR',
    img: benitoImg,
    phrases: {
      normal: [
        'Primera jugada. Como el primer tiempo: se define poco.',
        'Bloquear acá es como sacar a un 9 que no corre.',
        'El centro es el mediocampo. Quien lo controla, controla el partido.',
        'Las estadísticas de esta partida son como las tangas: muestran todo menos lo importante.',
        'No hace falta gritar. El silencio también gana partidos.',
        'Siguiente partida. El fútbol, y el tatetí, siempre dan revancha.',
        'Jugar sin plan es como salir a presionar sin línea.',
        'Los partidos se ganan en los detalles que nadie mira.',
      ],
      pensando: [
        'Primera jugada. Como el primer tiempo: se define poco.',
        'Las estadísticas de esta partida son como las tangas: muestran todo menos lo importante.',
        'Pensar es la parte del juego que nadie aplaude.',
        'Leer el partido lleva más tiempo que jugarlo.',
      ],
      apurado: [
        'No hace falta gritar. El silencio también gana partidos.',
        'Bloquear acá es como sacar a un 9 que no corre.',
        'El reloj es el rival más honesto que vas a tener.',
        'Apurarse es la forma más elegante de errar.',
      ],
      risa: [
        'Gané. Sin gritos, solo con hechos.',
        'Esta es una victoria de las que no se celebran mucho, pero pesan.',
        'Ganar callado es ganar dos veces.',
      ],
      enojo: [
        'Perdí. Como una final que se define por detalles.',
        'Siguiente partida. El fútbol, y el tatetí, siempre dan revancha.',
        'Perder enseña más que ganar. Aunque ahora no lo parezca.',
      ],
      cerca_ganar: [
        'Estoy a una casilla… y eso duele más que perder.',
        'Falta poco. Y lo que falta siempre es lo más difícil.',
      ],
      jaque_mate: [
        'Casi gano. Y el «casi» es el peor resultado.',
        'Perdí. Como una final que se define por detalles.',
        'Me leíste el partido mejor que yo. Pasa.',
      ],
    },
    wrongPick: [
      'Esa jugada tuya es como un lateral mal ejecutado: se nota.',
      'Ese jugador no pasó por ahí. Los datos no mienten.',
      'Bloquear acá es como sacar a un 9 que no corre.',
    ],
  },
];

// Sortea un personaje distinto del actual. Con `currentId` null (primera partida) sortea
// entre los 5; después excluye al que acaba de jugar para que cada ronda sea uno nuevo.
export const pickFour12Character = (currentId = null) => {
  const pool = currentId
    ? FOUR12_CHARACTERS.filter(c => c.id !== currentId)
    : FOUR12_CHARACTERS;
  return pool[Math.floor(Math.random() * pool.length)];
};

// ── Modo clásico vs bot: rival elegible ──────────────────────────────────────
// En el clásico el rival puede ser el bot de siempre o cualquiera de los 5 personajes de 412.
// El bot no es un "personaje" (no tiene objeto): se representa con BOT_RIVAL_ID y
// rivalCharacter() devuelve null, que es lo que BotCharacter entiende como "el bot".
export const BOT_RIVAL_ID = 'bot';

export const CLASSIC_RIVALS = [
  { id: BOT_RIVAL_ID, nombre: 'Bot TicTacToe' },
  ...FOUR12_CHARACTERS.map(({ id, nombre }) => ({ id, nombre })),
];

export const rivalCharacter = (id) =>
  FOUR12_CHARACTERS.find(c => c.id === id) || null;

// Sortea entre los 6 rivales, distinto del actual (igual que pickFour12Character).
export const pickClassicRival = (currentId = null) => {
  const pool = CLASSIC_RIVALS.filter(r => r.id !== currentId);
  return pool[Math.floor(Math.random() * pool.length)].id;
};
